import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AddressItem from '../../../../components/AddressItem';
import Icon, { Icons } from '../../../../components/Icon/Icon';
import PageHeader from '../../../../components/PageHeader';
import AppConfig from '../../../../config';
import { t } from '../../../../lang';
import RequestService from '../../../../services/RequestService';
import StorageService from '../../../../services/StorageService';
import TypesService from '../../../../services/TypesService';
import { sendSlice } from '../../../../store/slices';

import './CardWithdrawalAccount.scss';

const { routes } = AppConfig;

const BlockchainsById = TypesService.BlockchainsById;
const CurrenciesById = TypesService.CurrenciesById;

const CardWithdrawalAccount = () => {
	const [storedCardId, setStoredCardId] = useState();
	const [storedAssetId, setStoredAssetId] = useState();
	const [addressesLoading, setAddressesLoading] = useState(false);
	const [baseCurrencyAddress, setBaseCurrencyAddress] = useState();
	const [walletAddresses, setWalletAddresses] = useState([]);

	const availableCurrencies = useSelector(store => store.app.availableCurrencies);
	const cardsList = useSelector(state => state.card.cardsList);

	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const cardId = storedCardId || Number(searchParams.get('cardId'));
	const assetId = storedAssetId || Number(searchParams.get('assetId'));
	const card = cardsList.find(card => card.Id === cardId);
	const asset = availableCurrencies.find(currency => currency.Id === assetId);
	const cardAddress = card.Addresses.find(address => address.CurrencyId === assetId);

	const anotherCardsAddresses = cardsList
		.map(cardItem => {
			const address = cardItem.Addresses?.find(address => address.CurrencyId === assetId);
			if (cardItem.Id !== cardId && address) return address;
		})
		.filter(Boolean);
	const allSourceAddresses = [...walletAddresses, ...anotherCardsAddresses].sort((a, b) => b.AmountUsd - a.AmountUsd);

	const currencyData = CurrenciesById[assetId];
	const blockchainData = BlockchainsById[currencyData.BlockchainId];

	const getAddresses = async assetId => {
		try {
			setAddressesLoading(true);
			const response = await RequestService.GetAddressesByCurrency(assetId);
			setAddressesLoading(false);
			if (response?.Status === 'Success') {
				setWalletAddresses(response.Addresses);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const fetchBaseCurrencyAddress = async () => {
		try {
			const feeCurrencyId = Object.keys(TypesService.CurrenciesById).find(currencyId => {
				const currency = TypesService.CurrenciesById[currencyId];
				return currency.BlockchainId === currencyData.BlockchainId && !currency.Standart;
			});
			const numericFeeCurrencyId = Number(feeCurrencyId) || 0;

			const response = await RequestService.GetAddressesByCurrency(numericFeeCurrencyId);
			if (response.Status === 'Success') {
				const address = response.Addresses.find(address => address.Address === cardAddress.Address);
				setBaseCurrencyAddress(address);
			}
		} catch (error) {
			setBaseCurrencyAddress();
		}
	};

	useEffect(() => {
		setStoredCardId(cardId);
		setStoredAssetId(assetId);

		StorageService.UpdateQuotes();
		StorageService.UpdateTariffList();
		getAddresses(assetId);
	}, []);

	useEffect(() => {
		if (currencyData.FeeType === 'back_calculating' && !baseCurrencyAddress) {
			fetchBaseCurrencyAddress();
		}
	}, [asset]);

	const selectAddress = recipientAddress => {
		const feeData =
			currencyData.FeeType === 'back_calculating'
				? {
						CurrencyId: cardAddress.CurrencyId,
						BlockchainId: cardAddress.BlockchainId,
						Amount: baseCurrencyAddress?.Amount || 0,
						Fee: 0,
				  }
				: { Amount: 0, Fee: 0 };

		dispatch(
			sendSlice.actions.setSendData({
				asset,
				account: cardAddress,
				recipient: recipientAddress,
				feeData,
				minAmountUsd: 2,
				withdrawalCardId: cardId,
			})
		);
		navigate({ pathname: routes.sendAmount });
	};

	return (
		<div className='CardWithdrawalAccount'>
			<PageHeader
				header={'Select address'}
				subheader={<>{currencyData.Name + ' ' + blockchainData.Name + ' ' + currencyData.Standart}</>}
				icon={currencyData.CompanyIcon}
				iconLabel={currencyData.CompanyIcon !== blockchainData.Icon ? blockchainData.Icon : null}
			/>
			<div className='CardWithdrawalAccount__body'>
				{allSourceAddresses.length || addressesLoading ? (
					<div className='FormBlock'>
						{allSourceAddresses.map((address, index) => (
							<AddressItem
								key={index}
								address={address}
								lastItem={index === allSourceAddresses.length - 1}
								onClick={selectAddress}
							/>
						))}
					</div>
				) : (
					<div className='CardWithdrawalAccount__empty-state'>
						<Icon type={Icons.EMPTY_ACCOUNT_LIST_ICON} width={240} height={124} />
						<div className='CardWithdrawalAccount__empty-header'>{t('No addresses yet')}</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default CardWithdrawalAccount;
